import { DemographicApi } from 'api/DemographicApi';
import { backendApiClient } from 'container/backendApiClient';
import { reportApiClient } from 'container/reportApiClient';

export const demographicApi = new DemographicApi(backendApiClient, reportApiClient);
